import DateCell from '../../../../elements/Table/Cells/DateCell'
import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import _ from 'lodash'

function List(props) {
  const { list, isUpdatable, fetch, fetching, onShow, task } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      hideable: true,
      hideDefault: true,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'No',
      accessor: 'no',
      width: 75,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Title',
      accessor: 'title',
      style: { paddingLeft: 20, alignment: 'left' },
      width: 250,
    },
    //{Header: 'Activity', accessor: 'activity'},
    { Header: 'Complete By', accessor: 'due.date', Cell: DateCell, width: 150 },
    { Header: 'Assigned To', accessor: 'assignedTo.fn', width: 100 },
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell: ({ value }) => value && _.startCase(value),
    },
    { Header: 'Action' },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={onShow}
          disabled={!isUpdatable}>
          New Line
        </Button>
      )}
      columns={columns}
      show={{
        csv: {
          fileName: `[${task.code}]-Action-List`,
        },
      }}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
